<template>
  <div :class="classNames" data-test-alert>
    <span :class="iconClassNames" data-test-alert-icon></span>
    <span class="adn-alert__text" data-test-alert-text>
      <!-- @slot Use this slot to set the alert message -->
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AdnAlert',
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    theme: {
      type: String,
      validator: (val) => ['basic', 'inverted'].includes(val),
    },
    kind: {
      type: String,
      validator: (val) => ['success', 'info', 'danger', 'warning'].includes(val),
    },
  },
  computed: {
    classNames() {
      const classNames = ['adn-alert', `adn-alert--${this.kind}`]
      if (this.theme && this.theme !== 'basic') {
        classNames.push(`adn-alert--${this.theme}`)
      }
      if (this.centered) {
        classNames.push('adn-alert--centered')
      }
      return classNames
    },
    iconClassNames() {
      // Allow override
      if (this.icon) {
        const icon = this.icon.startsWith('adn-icon--') ? this.icon : `adn-icon--${this.icon}`
        return ['adn-icon', icon]
      }

      const kinds = {
        success: 'adn-icon--status-check',
        info: 'adn-icon--function-information',
        warning: 'adn-icon--function-warning',
        danger: 'adn-icon--status-unavailable',
      }
      const kind = kinds[this.kind]
      return ['adn-icon', kind]
    },
  },
}
</script>

<style lang="scss">
.adn-alert {
  position: relative;
}

.adn-alert--centered {
  text-align: center;
}

.adn-alert--success {
  color: var(--color-success);
}

.adn-alert--info {
  color: var(--color-text-light);
}

.adn-alert--warning {
  color: var(--color-warning);
}

.adn-alert--danger {
  color: var(--color-error);
}

.adn-alert__text {
  display: inline-block;
  text-align: left;
  font-weight: bold;
}

.adn-alert .adn-icon {
  position: absolute;

  + .adn-alert__text {
    margin-left: 3rem;
  }
}

.adn-alert--inverted {
  padding: 1rem;
  color: white;
}

.adn-alert--inverted.adn-alert--success {
  background-color: var(--color-success);
}

.adn-alert--inverted.adn-alert--info {
  background-color: var(--color-background);
  color: var(--color-text-light);
}

.adn-alert--inverted.adn-alert--warning {
  background-color: var(--color-warning);
  color: black;
}

.adn-alert--inverted.adn-alert--danger {
  background-color: var(--color-error);
}
</style>
